import dlv from 'dlv';
import { FieldValues } from 'react-hook-form';
import { ClaimUpdateRequest } from '../../../types/claim';
import { CLAIM_SPECIAL_FIELDS, DATE_PRECISION } from '../data/constants';
import { FormBuilder, FormShape } from '../types';
import {
	dateConversion,
	filterObjectByKeys,
	getPathsForForms,
	updateRequestBuilder,
} from '../utils';

const claimUpdateBuilder = (
	dirtyFields: { [key: string]: boolean },
	formValues: FieldValues,
	fields: FormShape<FormBuilder>,
	primaryFormName: string,
	timezone = 'America/Los_Angeles',
) => {
	const paths = getPathsForForms(fields, primaryFormName);
	let updateObject = {
		updateExposures: [],
		fieldValues: {},
		addFieldGroups: [],
	} as ClaimUpdateRequest;
	paths.forEach((key) => {
		if (Object.keys(dlv(dirtyFields, key, {})).length > 0) {
			let newUpdatedObject;
			const currDirtyFields = { [key]: dlv(dirtyFields, key, {}) };
			const currFormValues = { [key]: dlv(formValues, key, {}) };
			const currFields = {
				[key]: dlv(fields, key, {}),
			} as FormShape<FormBuilder>;

			if (
				dlv(
					currDirtyFields,
					`${key}.${CLAIM_SPECIAL_FIELDS.INCIDENT_DATE}`,
					false,
				)
			) {
				const incidentDate = dlv(
					currFormValues,
					`${key}.${CLAIM_SPECIAL_FIELDS.INCIDENT_DATE}`,
					'',
				);
				updateObject.incidentTimestamp =
					dateConversion.convertDateStringToZonedTimestamp(
						incidentDate,
						DATE_PRECISION.DAY,
						timezone,
					);
				currDirtyFields[`${key}.${CLAIM_SPECIAL_FIELDS.INCIDENT_DATE}`] = false;
			}
			if (
				dlv(
					currDirtyFields,
					`${key}.${CLAIM_SPECIAL_FIELDS.NOTIFICATION_DATE}`,
					false,
				)
			) {
				const notificationDate = dlv(
					currFormValues,
					`${key}.${CLAIM_SPECIAL_FIELDS.NOTIFICATION_DATE}`,
					'',
				);
				updateObject.notificationTimestamp =
					dateConversion.convertDateStringToZonedTimestamp(
						notificationDate,
						DATE_PRECISION.DAY,
						timezone,
					);
				currDirtyFields[`${key}.${CLAIM_SPECIAL_FIELDS.NOTIFICATION_DATE}`] =
					false;
			}

			const filteredCurrFormValues = {
				[key]: filterObjectByKeys(currFormValues[key], [
					CLAIM_SPECIAL_FIELDS.INCIDENT_DATE,
					CLAIM_SPECIAL_FIELDS.NOTIFICATION_DATE,
				]),
			};

			const filteredCurrDirtyFields = {
				[key]: filterObjectByKeys(currDirtyFields[key], [
					CLAIM_SPECIAL_FIELDS.INCIDENT_DATE,
					CLAIM_SPECIAL_FIELDS.NOTIFICATION_DATE,
				]),
			};

			newUpdatedObject = updateRequestBuilder<ClaimUpdateRequest>(
				filteredCurrDirtyFields,
				filteredCurrFormValues,
				currFields,
				key,
				timezone,
			);
			updateObject = { ...updateObject, ...newUpdatedObject };
		}
	});
	return updateObject;
};

export default claimUpdateBuilder;
